import { Component, OnInit } from '@angular/core';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { OptionService } from '../../services/option.service';

import { OptionsControlBaseComponent } from '../options-control-base/options-control-base.component';
import { ControlTypeName } from '../../types/control-type-name';
import { ControlValidateMoment } from '../../types/validator.types';
import { OptionItem } from '../../types/control.types';

@Component({
  selector: 'df-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css']
})
export class DropDownComponent extends OptionsControlBaseComponent<OptionItem> implements OnInit {
  type = ControlTypeName.dropDown;
  constructor(protected commonConfig: DynamicFormCommonConfig, protected service: OptionService) {
    super(commonConfig, service);
  }

  ngOnInit() {
    if (!this.model.placeholder) {
      this.model.placeholder = 'è¯·éæ©';
    }
    if (!this.model.value) {
      this.model.value = '';
    }
    super.ngOnInit();
  }

  change(event: any) {
    this.validateAtMoment(ControlValidateMoment.Input);
    this.validateAtMoment(ControlValidateMoment.Change);
    this.broadControlValueChange();
  }

  getCheckedText(): string {
    if (!this.showOptions) {
      return '';
    }

    const checkedOption = this.showOptions.find((s) => s.id === this.model.value);
    if (checkedOption) {
      return checkedOption.text;
    }
    return '';
  }
}
